import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { State } from '../../../model/eform-type';
import { EFormHelper } from '../../../helper/script/helper';
import { TestValueService } from '../../../service/testvalue.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-textbox-properties',
  templateUrl: './textbox-properties.component.html',
  styleUrls: ['./textbox-properties.component.scss']
})
export class TextboxPropertiesComponent implements OnInit {
  @Input() eForm: FormGroup;
  @Input() state: State;
  @Input() table: any;
  @Output() sendFocus = new EventEmitter<boolean>();
  fieldGroup: FormGroup;
  testValue: FormControl;
  isErrorMaxLength: boolean;
  helper = new EFormHelper();
  displayDisabled: boolean = false;
  @Input() eventsStateChild: Observable<void>;

  constructor(public service: TestValueService, public translate: TranslateService) {
  }

  ngOnInit(): void {
   this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
   this.helper.displayDisabledChanges.subscribe((value) => {
      this.displayDisabled = value;
   });
   this.eventsStateChild.subscribe(() => {
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
   });
   const element = document.getElementById('control-textbox-properties');
   element.focus();
   setTimeout( () => { element.focus(); }, 1);
   if (this.getField.value.maxLength) {
      this.isErrorMaxLength = false;
   } else {
      this.isErrorMaxLength = true;
   }
  }

  addRegex() {
    this.fieldGroup = null;
    this.fieldGroup = (this.table) ? this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex)
        : this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
    this.service.clearValue();
    if (!this.fieldGroup.controls.isRegex.value) {
      this.fieldGroup.addControl('regex', new FormControl('', Validators.required));
      this.fieldGroup.addControl('regexMessage', new FormGroup({
         'th' : new FormControl(''),
         'en' : new FormControl(''),
         'cn' : new FormControl('')
      }));
      const _regexMsg = this.fieldGroup.get('regexMessage') as FormGroup;
      _regexMsg.controls[this.eForm.controls.original.value].setValidators(Validators.required);
    } else {
      this.fieldGroup.removeControl('regex');
      this.fieldGroup.removeControl('regexMessage');
    }
    this.fieldGroup.markAllAsTouched();
  }

  mustType(length: number) {
     const _tmpGroup = this.getField.controls.maxLength;
     const _value  = length > 255 ?  255 : length < 1 ? '' : length;
     if (_value === '') {
         this.isErrorMaxLength = true;
     } else {
         this.isErrorMaxLength = false;
     }
     _tmpGroup.setValue( _value );
  }

  sendFocusToCreate(focus: boolean) {
   this.sendFocus.emit(focus);
}

   get getField() {
      if (this.table) {
         return this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
      }
      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
   }



}
